<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts';
require('echarts/theme/macarons'); // echarts theme
import resize from '@/views/common/dashboard/admin/components/mixins/resize';

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '700px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions(this.chartData);
    },
    setOptions() {
      this.chart.setOption({
        title: this.chartData.title,
        grid: {
          top: '15%',
          left: '40',
          right: '40',
          bottom: '10%',
          containLabel: true
        },
        tooltip: this.chartData.tooltip,
        toolbox: {
          show: true,
          right: '3%',
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            restore: {},
            saveAsImage: {}
          },
          iconStyle: {
            borderColor: '#082dc3'
          },
          emphasis: {
            iconStyle: {
              borderColor: '#082dc3'
            }
          }
        },
        xAxis: {
          data: this.chartData.xAxisData,
          type: 'category',
          axisLine: {
            show: false,
            lineStyle: {
              color: 'black'
            }
          },
          axisLabel: {
            color: 'black',
            margin: 20
          },
          splitLine: {
            show: false
          },
          showScrollbar: false,
          boundaryGap: false,
        },
        yAxis: this.chartData.yAxis,
        dataZoom: [
          {
            // type: 'inside', // 这是滚动条的类型
            // xAxisIndex: 0, // 这是控制哪个X轴使用滚动条，如果有多个X轴，可以根据实际情况设置
            start: 30,
            end: 100,
          }
        ],
        legend: {},
        series: this.chartData.series
      });
    }
  }
};
</script>

